













































































































import ModalBox from '@/modules/core/components/ModalBox.vue';
import { userApi } from '../user.api';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BaseTable from '@/modules/core/components/BaseTable';
import UserDeleteBtn from './UserDeleteBtn.vue';
import UserEditBtn from './UserEditBtn.vue';
import { PaginationResult, PermissionType } from '@shared/common/types';
import { User } from '../user';

@Component({
  components: {
    ModalBox,
    UserEditBtn,
    UserDeleteBtn,
  },
})
export default class UsersTable extends BaseTable {
  @Prop({
    default: () => [],
  })
  public roles!: string[];

  public PermissionType: typeof PermissionType = PermissionType;

  public filters: any = {
    deleted: 'NOT_DELETED',
  };

  public buildFilters(gridFilters: any): void {
    this.$super(BaseTable).buildFilters(gridFilters);
    this.filters.roles = this.roles;
  }

  public async fetchData(): Promise<PaginationResult<User>> {
    return await userApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  @Watch('roles')
  public onRolesChange(): void {
    this.buildFilters(this.gridFilters);
  }
}
